import { i as gt } from "./is-object-Bibs6Kbh.js";
import { c as nr, a as rr, m as ir, s as or, b as sr, d as ar, t as cr } from "./serializers-D22JtxUA.js";
import { parse as it } from "personnummer.js";
function Ze(t) {
  const e = new URL(t, globalThis.location?.origin);
  return e.pathname = e.pathname.replace(/\/graphql\/?$/, ""), e.pathname.endsWith("/") || (e.pathname = `${e.pathname}/`), e.toString();
}
function Ve(t) {
  return t.extensions && "exception" in t.extensions && gt(t.extensions.exception) && "errcode" in t.extensions.exception && typeof t.extensions.exception.errcode == "string" ? t.extensions.exception.errcode : void 0;
}
const Xe = () => {
}, Qe = () => {
};
class pt extends Error {
  constructor(e = "Circuit breaker is open") {
    super(e), this.name = "CircuitBreakerOpenError";
  }
}
class Je {
  constructor(e) {
    this.options = e;
  }
  #t = "CLOSED";
  #e = 0;
  #n = 0;
  #i = 0;
  #r = 0;
  #s() {
    return this.options.now?.() ?? Date.now();
  }
  #o(e) {
    if (this.#t = e, e === "CLOSED") {
      this.#e = 0, this.#n = 0, this.#i = 0, this.#r = 0;
      return;
    }
    if (e === "OPEN") {
      this.#i = this.#s() + this.options.openDurationMs, this.#n = 0, this.#r = 0;
      return;
    }
    this.#e = 0, this.#n = 0, this.#r = 0;
  }
  allowRequest() {
    if (this.#t === "CLOSED") return !0;
    if (this.#t === "OPEN")
      if (this.#s() >= this.#i)
        this.#o("HALF_OPEN");
      else
        return !1;
    return this.#r < this.options.halfOpenMaxConcurrent;
  }
  recordSuccess() {
    if (this.#t === "HALF_OPEN") {
      this.#n += 1, this.#n >= this.options.successThreshold && this.#o("CLOSED");
      return;
    }
    this.#e = 0;
  }
  recordFailure() {
    if (this.#t === "HALF_OPEN") {
      this.#o("OPEN");
      return;
    }
    this.#e += 1, this.#e >= this.options.failureThreshold && this.#o("OPEN");
  }
  // eslint-disable-next-line unicorn/prevent-abbreviations
  async exec(e) {
    if (!this.allowRequest()) throw new pt();
    const n = this.#t === "HALF_OPEN";
    n && this.#r++;
    try {
      const r = await e();
      return this.recordSuccess(), r;
    } catch (r) {
      throw this.options.isFailure(r) ? this.recordFailure() : this.recordSuccess(), r;
    } finally {
      n && this.#r--;
    }
  }
  snapshot() {
    return {
      state: this.#t,
      failures: this.#e,
      openedUntil: this.#i,
      halfOpenSuccesses: this.#n
    };
  }
}
function yt(t, e, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: t,
    timeZoneName: n
  }).format(e).split(/\s/g).slice(2).join(" ");
}
const wt = {}, I = {};
function S(t, e) {
  try {
    const r = (wt[t] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: t,
      timeZoneName: "longOffset"
    }).format)(e).split("GMT")[1];
    return r in I ? I[r] : j(r, r.split(":"));
  } catch {
    if (t in I) return I[t];
    const n = t?.match(Tt);
    return n ? j(t, n.slice(1)) : NaN;
  }
}
const Tt = /([+-]\d\d):?(\d\d)?/;
function j(t, e) {
  const n = +(e[0] || 0), r = +(e[1] || 0), i = +(e[2] || 0) / 60;
  return I[t] = n * 60 + r > 0 ? n * 60 + r + i : n * 60 - r - i;
}
class T extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(S(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), ot(this), z(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new T(...n, e) : new T(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new T(+this, e);
  }
  getTimezoneOffset() {
    const e = -S(this.timeZone, this);
    return e > 0 ? Math.floor(e) : Math.ceil(e);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), z(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new T(+new Date(e), this.timeZone);
  }
  //#endregion
}
const G = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!G.test(t)) return;
  const e = t.replace(G, "$1UTC");
  T.prototype[e] && (t.startsWith("get") ? T.prototype[t] = function() {
    return this.internal[e]();
  } : (T.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), bt(this), +this;
  }, T.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), z(this), +this;
  }));
});
function z(t) {
  t.internal.setTime(+t), t.internal.setUTCSeconds(t.internal.getUTCSeconds() - Math.round(-S(t.timeZone, t) * 60));
}
function bt(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), ot(t);
}
function ot(t) {
  const e = S(t.timeZone, t), n = e > 0 ? Math.floor(e) : Math.ceil(e), r = /* @__PURE__ */ new Date(+t);
  r.setUTCHours(r.getUTCHours() - 1);
  const i = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), o = -(/* @__PURE__ */ new Date(+r)).getTimezoneOffset(), s = i - o, c = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  s && c && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + s);
  const d = i - n;
  d && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + d);
  const l = /* @__PURE__ */ new Date(+t);
  l.setUTCSeconds(0);
  const f = i > 0 ? l.getSeconds() : (l.getSeconds() - 60) % 60, u = Math.round(-(S(t.timeZone, t) * 60)) % 60;
  (u || f) && (t.internal.setUTCSeconds(t.internal.getUTCSeconds() + u), Date.prototype.setUTCSeconds.call(t, Date.prototype.getUTCSeconds.call(t) + u + f));
  const p = S(t.timeZone, t), y = p > 0 ? Math.floor(p) : Math.ceil(p), m = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - y, h = y !== n, k = m - d;
  if (h && k) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + k);
    const U = S(t.timeZone, t), ht = U > 0 ? Math.floor(U) : Math.ceil(U), F = y - ht;
    F && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + F), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + F));
  }
}
class O extends T {
  //#region static
  static tz(e, ...n) {
    return n.length ? new O(...n, e) : new O(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, r] = this.tzComponents(), i = `${e}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + i;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, r, i] = this.internal.toUTCString().split(" ");
    return `${e?.slice(0, -1)} ${r} ${n} ${i}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, r, i] = this.tzComponents();
    return `${e} GMT${n}${r}${i} (${yt(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", r = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), i = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, r, i];
  }
  //#endregion
  withTimeZone(e) {
    return new O(+this, e);
  }
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new O(+new Date(e), this.timeZone);
  }
  //#endregion
}
const st = (t) => (e) => O.tz(t, +new Date(e)), at = 6048e5, Dt = 864e5, Z = 6e4, V = 525600, X = 43200, Q = 1440, J = /* @__PURE__ */ Symbol.for("constructDateFrom");
function w(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && J in t ? t[J](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function g(t, e) {
  return w(e || t, t);
}
function q(t, e, n) {
  const r = g(t, n?.in);
  return isNaN(e) ? w(t, NaN) : (e && r.setDate(r.getDate() + e), r);
}
let St = {};
function A() {
  return St;
}
function x(t, e) {
  const n = A(), r = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = g(t, e?.in), o = i.getDay(), s = (o < r ? 7 : 0) + o - r;
  return i.setDate(i.getDate() - s), i.setHours(0, 0, 0, 0), i;
}
function R(t, e) {
  return x(t, { ...e, weekStartsOn: 1 });
}
function ct(t, e) {
  const n = g(t, e?.in), r = n.getFullYear(), i = w(n, 0);
  i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const o = R(i), s = w(n, 0);
  s.setFullYear(r, 0, 4), s.setHours(0, 0, 0, 0);
  const c = R(s);
  return n.getTime() >= o.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function W(t) {
  const e = g(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function ut(t, ...e) {
  const n = w.bind(
    null,
    t || e.find((r) => typeof r == "object")
  );
  return e.map(n);
}
function E(t, e) {
  const n = g(t, e?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Nt(t, e, n) {
  const [r, i] = ut(
    n?.in,
    t,
    e
  ), o = E(r), s = E(i), c = +o - W(o), d = +s - W(s);
  return Math.round((c - d) / Dt);
}
function Mt(t, e) {
  const n = ct(t, e), r = w(t, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), R(r);
}
function Ot(t, e) {
  let n, r = e?.in;
  return t.forEach((i) => {
    !r && typeof i == "object" && (r = w.bind(null, i));
    const o = g(i, r);
    (!n || n > o || isNaN(+o)) && (n = o);
  }), w(r, n || NaN);
}
function Et(t, e) {
  const n = +g(t) - +g(e);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function Pt(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Ct(t) {
  return !(!Pt(t) && typeof t != "number" || isNaN(+g(t)));
}
function It(t) {
  return (e) => {
    const r = (t ? Math[t] : Math.trunc)(e);
    return r === 0 ? 0 : r;
  };
}
function vt(t, e) {
  const n = g(t, e?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const xt = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, _t = (t, e, n) => {
  let r;
  const i = xt[t];
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : r = i.other.replace("{{count}}", e.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function $(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const At = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, kt = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ut = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Rt = {
  date: $({
    formats: At,
    defaultWidth: "full"
  }),
  time: $({
    formats: kt,
    defaultWidth: "full"
  }),
  dateTime: $({
    formats: Ut,
    defaultWidth: "full"
  })
}, Wt = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Yt = (t, e, n, r) => Wt[t];
function P(t) {
  return (e, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && t.formattingValues) {
      const s = t.defaultFormattingWidth || t.defaultWidth, c = n?.width ? String(n.width) : s;
      i = t.formattingValues[c] || t.formattingValues[s];
    } else {
      const s = t.defaultWidth, c = n?.width ? String(n.width) : t.defaultWidth;
      i = t.values[c] || t.values[s];
    }
    const o = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[o];
  };
}
const Ft = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, $t = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Lt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Ht = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, zt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, qt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Bt = (t, e) => {
  const n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, jt = {
  ordinalNumber: Bt,
  era: P({
    values: Ft,
    defaultWidth: "wide"
  }),
  quarter: P({
    values: $t,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: P({
    values: Lt,
    defaultWidth: "wide"
  }),
  day: P({
    values: Ht,
    defaultWidth: "wide"
  }),
  dayPeriod: P({
    values: zt,
    defaultWidth: "wide",
    formattingValues: qt,
    defaultFormattingWidth: "wide"
  })
};
function C(t) {
  return (e, n = {}) => {
    const r = n.width, i = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], o = e.match(i);
    if (!o)
      return null;
    const s = o[0], c = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], d = Array.isArray(c) ? Zt(c, (u) => u.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      Gt(c, (u) => u.test(s))
    );
    let l;
    l = t.valueCallback ? t.valueCallback(d) : d, l = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(l)
    ) : l;
    const f = e.slice(s.length);
    return { value: l, rest: f };
  };
}
function Gt(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function Zt(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function Vt(t) {
  return (e, n = {}) => {
    const r = e.match(t.matchPattern);
    if (!r) return null;
    const i = r[0], o = e.match(t.parsePattern);
    if (!o) return null;
    let s = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const c = e.slice(i.length);
    return { value: s, rest: c };
  };
}
const Xt = /^(\d+)(th|st|nd|rd)?/i, Qt = /\d+/i, Jt = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Kt = {
  any: [/^b/i, /^(a|c)/i]
}, te = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, ee = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ne = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, re = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, ie = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, oe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, se = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ae = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ce = {
  ordinalNumber: Vt({
    matchPattern: Xt,
    parsePattern: Qt,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: C({
    matchPatterns: Jt,
    defaultMatchWidth: "wide",
    parsePatterns: Kt,
    defaultParseWidth: "any"
  }),
  quarter: C({
    matchPatterns: te,
    defaultMatchWidth: "wide",
    parsePatterns: ee,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: C({
    matchPatterns: ne,
    defaultMatchWidth: "wide",
    parsePatterns: re,
    defaultParseWidth: "any"
  }),
  day: C({
    matchPatterns: ie,
    defaultMatchWidth: "wide",
    parsePatterns: oe,
    defaultParseWidth: "any"
  }),
  dayPeriod: C({
    matchPatterns: se,
    defaultMatchWidth: "any",
    parsePatterns: ae,
    defaultParseWidth: "any"
  })
}, lt = {
  code: "en-US",
  formatDistance: _t,
  formatLong: Rt,
  formatRelative: Yt,
  localize: jt,
  match: ce,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function ue(t, e) {
  const n = g(t, e?.in);
  return Nt(n, vt(n)) + 1;
}
function le(t, e) {
  const n = g(t, e?.in), r = +R(n) - +Mt(n);
  return Math.round(r / at) + 1;
}
function ft(t, e) {
  const n = g(t, e?.in), r = n.getFullYear(), i = A(), o = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, s = w(e?.in || t, 0);
  s.setFullYear(r + 1, 0, o), s.setHours(0, 0, 0, 0);
  const c = x(s, e), d = w(e?.in || t, 0);
  d.setFullYear(r, 0, o), d.setHours(0, 0, 0, 0);
  const l = x(d, e);
  return +n >= +c ? r + 1 : +n >= +l ? r : r - 1;
}
function fe(t, e) {
  const n = A(), r = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, i = ft(t, e), o = w(e?.in || t, 0);
  return o.setFullYear(i, 0, r), o.setHours(0, 0, 0, 0), x(o, e);
}
function de(t, e) {
  const n = g(t, e?.in), r = +x(n, e) - +fe(n, e);
  return Math.round(r / at) + 1;
}
function a(t, e) {
  const n = t < 0 ? "-" : "", r = Math.abs(t).toString().padStart(e, "0");
  return n + r;
}
const b = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), r = n > 0 ? n : 1 - n;
    return a(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : a(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return a(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return a(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return a(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return a(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return a(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, r = t.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return a(i, e.length);
  }
}, M = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, K = {
  // Era
  G: function(t, e, n) {
    const r = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const r = t.getFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return b.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, r) {
    const i = ft(t, r), o = i > 0 ? i : 1 - i;
    if (e === "YY") {
      const s = o % 100;
      return a(s, 2);
    }
    return e === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : a(o, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = ct(t);
    return a(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return a(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return a(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return a(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return b.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return a(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, r) {
    const i = de(t, r);
    return e === "wo" ? n.ordinalNumber(i, { unit: "week" }) : a(i, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const r = le(t);
    return e === "Io" ? n.ordinalNumber(r, { unit: "week" }) : a(r, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : b.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const r = ue(t);
    return e === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : a(r, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const r = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, r) {
    const i = t.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return a(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, r) {
    const i = t.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return a(o, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const r = t.getDay(), i = r === 0 ? 7 : r;
    switch (e) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return a(i, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const i = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const r = t.getHours();
    let i;
    switch (r === 12 ? i = M.noon : r === 0 ? i = M.midnight : i = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const r = t.getHours();
    let i;
    switch (r >= 17 ? i = M.evening : r >= 12 ? i = M.afternoon : r >= 4 ? i = M.morning : i = M.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let r = t.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return b.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : b.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const r = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : a(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let r = t.getHours();
    return r === 0 && (r = 24), e === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : a(r, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : b.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : b.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return b.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = t.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return et(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return D(r);
      // Hours and minutes with `:` delimiter
      default:
        return D(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return et(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return D(r);
      // Hours and minutes with `:` delimiter
      default:
        return D(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + tt(r, ":");
      default:
        return "GMT" + D(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + tt(r, ":");
      default:
        return "GMT" + D(r, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const r = Math.trunc(+t / 1e3);
    return a(r, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return a(+t, e.length);
  }
};
function tt(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), i = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(i) : n + String(i) + e + a(o, 2);
}
function et(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + a(Math.abs(t) / 60, 2) : D(t, e);
}
function D(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), i = a(Math.trunc(r / 60), 2), o = a(r % 60, 2);
  return n + i + e + o;
}
const nt = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    default:
      return e.date({ width: "full" });
  }
}, dt = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    default:
      return e.time({ width: "full" });
  }
}, me = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return nt(t, e);
  let o;
  switch (r) {
    case "P":
      o = e.dateTime({ width: "short" });
      break;
    case "PP":
      o = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = e.dateTime({ width: "long" });
      break;
    default:
      o = e.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", nt(r, e)).replace("{{time}}", dt(i, e));
}, he = {
  p: dt,
  P: me
}, ge = /^D+$/, pe = /^Y+$/, ye = ["D", "DD", "YY", "YYYY"];
function we(t) {
  return ge.test(t);
}
function Te(t) {
  return pe.test(t);
}
function be(t, e, n) {
  const r = De(t, e, n);
  if (console.warn(r), ye.includes(t)) throw new RangeError(r);
}
function De(t, e, n) {
  const r = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Se = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ne = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Me = /^'([^]*?)'?$/, Oe = /''/g, Ee = /[a-zA-Z]/;
function rt(t, e, n) {
  const r = A(), i = r.locale ?? lt, o = r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, s = r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, c = g(t, n?.in);
  if (!Ct(c))
    throw new RangeError("Invalid time value");
  let d = e.match(Ne).map((f) => {
    const u = f[0];
    if (u === "p" || u === "P") {
      const p = he[u];
      return p(f, i.formatLong);
    }
    return f;
  }).join("").match(Se).map((f) => {
    if (f === "''")
      return { isToken: !1, value: "'" };
    const u = f[0];
    if (u === "'")
      return { isToken: !1, value: Pe(f) };
    if (K[u])
      return { isToken: !0, value: f };
    if (u.match(Ee))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + u + "`"
      );
    return { isToken: !1, value: f };
  });
  i.localize.preprocessor && (d = i.localize.preprocessor(c, d));
  const l = {
    firstWeekContainsDate: o,
    weekStartsOn: s,
    locale: i
  };
  return d.map((f) => {
    if (!f.isToken) return f.value;
    const u = f.value;
    (Te(u) || we(u)) && be(u, e, String(t));
    const p = K[u[0]];
    return p(c, u, i.localize, l);
  }).join("");
}
function Pe(t) {
  const e = t.match(Me);
  return e ? e[1].replace(Oe, "'") : t;
}
function Ce(t, e, n) {
  const r = A(), i = n?.locale ?? r.locale ?? lt, o = Et(t, e);
  if (isNaN(o))
    throw new RangeError("Invalid time value");
  const s = Object.assign({}, n, {
    addSuffix: n?.addSuffix,
    comparison: o
  }), [c, d] = ut(
    n?.in,
    ...o > 0 ? [e, t] : [t, e]
  ), l = It(n?.roundingMethod ?? "round"), f = d.getTime() - c.getTime(), u = f / Z, p = W(d) - W(c), y = (f - p) / Z, N = n?.unit;
  let m;
  if (N ? m = N : u < 1 ? m = "second" : u < 60 ? m = "minute" : u < Q ? m = "hour" : y < X ? m = "day" : y < V ? m = "month" : m = "year", m === "second") {
    const h = l(f / 1e3);
    return i.formatDistance("xSeconds", h, s);
  } else if (m === "minute") {
    const h = l(u);
    return i.formatDistance("xMinutes", h, s);
  } else if (m === "hour") {
    const h = l(u / 60);
    return i.formatDistance("xHours", h, s);
  } else if (m === "day") {
    const h = l(y / Q);
    return i.formatDistance("xDays", h, s);
  } else if (m === "month") {
    const h = l(y / X);
    return h === 12 && N !== "month" ? i.formatDistance("xYears", 1, s) : i.formatDistance("xMonths", h, s);
  } else {
    const h = l(y / V);
    return i.formatDistance("xYears", h, s);
  }
}
function v(t, e) {
  const n = g(t, e?.in);
  if (isNaN(+n))
    throw new RangeError("Invalid time value");
  const r = e?.format ?? "extended", i = e?.representation ?? "complete";
  let o = "", s = "";
  const c = r === "extended" ? "-" : "", d = r === "extended" ? ":" : "";
  if (i !== "time") {
    const l = a(n.getDate(), 2), f = a(n.getMonth() + 1, 2);
    o = `${a(n.getFullYear(), 4)}${c}${f}${c}${l}`;
  }
  if (i !== "date") {
    const l = n.getTimezoneOffset();
    if (l !== 0) {
      const m = Math.abs(l), h = a(Math.trunc(m / 60), 2), k = a(m % 60, 2);
      s = `${l < 0 ? "+" : "-"}${h}:${k}`;
    } else
      s = "Z";
    const f = a(n.getHours(), 2), u = a(n.getMinutes(), 2), p = a(n.getSeconds(), 2), y = o === "" ? "" : "T", N = [f, u, p].join(d);
    o = `${o}${y}${N}${s}`;
  }
  return o;
}
function Ke(t) {
  if (!Ie(t))
    throw new Error(`Expected YYYY-MM-DD date string, got: ${t}`);
  return /* @__PURE__ */ new Date(`${t}T00:00:00.000Z`);
}
function tn({
  startAt: t,
  endAt: e
}) {
  const n = st("UTC");
  let r = E(t, { in: n });
  const i = E(e, { in: n }), o = [];
  for (; r <= i; )
    o.push(v(r, { in: n, representation: "date" })), r = q(r, 1);
  return o;
}
function en({
  end_at: t,
  start_at: e
}) {
  return t.getTime() > e.getTime();
}
function nn({
  date: t,
  locale: e,
  timeZone: n
}) {
  const r = t.toLocaleString(e, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: n
  });
  return r.slice(0, 1).toUpperCase() + r.slice(1);
}
function Ie(t) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(t))
    return !1;
  const e = /* @__PURE__ */ new Date(`${t}T00:00:00.000Z`);
  return !Number.isNaN(e.getTime()) && e.toISOString().slice(0, 10) === t;
}
function rn({
  daysPerPartition: t,
  endAt: e,
  startAt: n,
  timeZone: r
}) {
  const i = r ? st(r) : void 0;
  if (t === void 0 || !Number.isFinite(t))
    return [
      {
        startDate: v(n, { in: i, representation: "date" }),
        endDate: v(e, { in: i, representation: "date" })
      }
    ];
  if (t <= 0)
    throw new Error('Property "daysPerPartition" must be greater than 0.');
  if (!Number.isInteger(t))
    throw new TypeError('Property "daysPerPartition" must be an integer.');
  n = E(n, { in: i }), e = E(e, { in: i });
  const o = [];
  for (; n <= e; ) {
    const s = v(n, {
      in: i,
      representation: "date"
    }), c = v(
      Ot([q(n, t - 1), e]),
      { in: i, representation: "date" }
    );
    o.push({ startDate: s, endDate: c }), n = q(n, t);
  }
  return o;
}
const ve = new RegExp("(?<=^| )(?:noll|en|två|tre|fyra|fem|sex|sju|åtta|nio|tio|elva|tolv|seconds?|sekund(?:er)?|minutes?|minut(?:er)?)(?= |$)", "g"), xe = {
  noll: "0",
  en: "1",
  två: "2",
  tre: "3",
  fyra: "4",
  fem: "5",
  sex: "6",
  sju: "7",
  åtta: "8",
  nio: "9",
  tio: "10",
  elva: "11",
  tolv: "12",
  second: "sec",
  seconds: "secs",
  sekund: "sek",
  sekunder: "sek",
  minute: "min",
  minutes: "mins",
  minut: "min",
  minuter: "min"
};
function on({
  addSuffix: t,
  fromDate: e,
  locale: n,
  toDate: r
}) {
  return Ce(r, e, {
    addSuffix: t,
    locale: n
  }).replaceAll(
    ve,
    (i) => xe[i] ?? i
  );
}
function sn(t) {
  return t.normalize("NFD").replaceAll(/[\u0300-\u036F]/g, "");
}
const an = Object.entries;
function cn(t, e) {
  const n = t.findIndex((r) => e(r));
  return n === -1 ? t.length : n;
}
function un({
  bookingType: t,
  fallback: e
}) {
  return (t?.visibleName ?? t?.name) || e;
}
function L({ min: t, max: e }) {
  return t + Math.floor(Math.random() * (e - t));
}
function ln(t = {}) {
  const e = (t.organizationNumber ?? L({ min: 1e9, max: 1e10 }).toString()).toUpperCase(), n = t.serialNumberLength ?? t.serialNumber?.length ?? L({ min: 4, max: 12 }), r = (t.serialNumber ?? L({ min: 0, max: 16 ** n }).toString(16)).slice(0, n).padStart(n, "0").toUpperCase();
  return ["SE", e, "-", r].join("");
}
function _e(t) {
  const e = t.trim().toUpperCase();
  return /^SE[\dA-Z]{8,14}-[\dA-Z]{1,16}$/.test(e) ? { valid: !0, normalized: e, type: "HSA_ID" } : { valid: !1 };
}
function fn(t) {
  return _e(t).valid;
}
function B(t) {
  const e = t.replaceAll(/\s/g, "");
  if (!/^\d{10}$/.test(e))
    return { valid: !1 };
  const n = [...e].map(Number), r = n.pop();
  let i = 0;
  for (const [s, c] of n.entries())
    i += c * (10 - s);
  const o = 11 - i % 11;
  return o === 11 ? r === 0 ? { valid: !0, normalized: e, type: "NHS_NUMBER" } : { valid: !1 } : o === 10 ? { valid: !1 } : r === o ? { valid: !0, normalized: e, type: "NHS_NUMBER" } : { valid: !1 };
}
function dn(t) {
  const e = B(t);
  return e.valid && e.type === "NHS_NUMBER";
}
function Ae({
  // By default, generate a random birth date between 1970 (the Unix epoch) and now:
  birthDate: t = new Date(Math.random() * Date.now()),
  gender: e = Math.random() >= 0.5 ? "female" : "male",
  // The first two digits of the three-digit birth number, 1-99. Random by
  // default; pass one to make the result reproducible, so that a caller
  // seeding a fixture gets the same identity number on every run. The same
  // birthDate, gender and serialNumber always produce the same identifier.
  //
  // Zero is excluded because it yields the birth number 000 for a female,
  // which Skatteverket does not issue. The gender digit is derived from
  // serialNumber rather than drawn separately, which is what makes an explicit
  // one reproducible -- so for a fixed birthDate and gender the random default
  // now picks between 99 identifiers rather than 500.
  serialNumber: n = 1 + Math.floor(Math.random() * 99)
} = {}) {
  if (!Number.isInteger(n) || n < 1 || n > 99)
    throw new RangeError(
      `serialNumber must be an integer between 1 and 99, got ${n}`
    );
  const r = (n % 5 * 2 + (e === "male" ? 1 : 0)).toString(), i = n.toString().padStart(2, "0") + r, o = [
    rt(t, "yyyyMMdd"),
    i,
    ke([rt(t, "yyMMdd"), i].join(""))
  ].join(""), s = Ue({
    identifier: o,
    format: "YYYYMMDDNNNN"
  });
  if (!s)
    throw new Error(
      `Generated invalid personnummer: ${o}`
    );
  return s;
}
function ke(t) {
  let e = 0;
  const n = t.length;
  for (let r = 0; r < n; r++) {
    let i = Number.parseInt(t.charAt(r));
    i *= 2 - r % 2, i > 9 && (i -= 9), e += i;
  }
  return ((10 - e % 10) % 10).toString();
}
function _(t) {
  const {
    valid: e,
    normalised: n,
    type: r,
    gender: i,
    age: o
  } = it(t, {
    forgiving: !0,
    normaliseFormat: "YYYYMMDDNNNN"
  });
  return !e || !n || !i || o === void 0 || !r ? { valid: !1 } : {
    valid: !0,
    normalized: n,
    type: r === "PERSONNUMMER" ? "SWEDISH_PERSONAL_NUMBER" : "SWEDISH_COORDINATION_NUMBER",
    gender: i,
    age: o
  };
}
function mn(t) {
  const e = _(t);
  return e.valid && e.type === "SWEDISH_PERSONAL_NUMBER";
}
function hn(t) {
  const e = _(t);
  return e.valid && e.type === "SWEDISH_COORDINATION_NUMBER";
}
function gn(t) {
  return _(t).valid;
}
function Ue({
  identifier: t,
  format: e
}) {
  const n = it(t, {
    forgiving: !0,
    normaliseFormat: e
  });
  return n.valid ? n.normalised : void 0;
}
function Re({
  identifier: t,
  geography: e
}) {
  const n = e === "UK" || e === "WLS" ? [B] : e === "SE" ? [_] : [B, _];
  for (const r of n) {
    const i = r(t);
    if (i.valid)
      return {
        valid: !0,
        normalized: i.normalized,
        type: i.type
      };
  }
  return { valid: !1 };
}
function pn({
  identifier: t,
  geography: e
}) {
  return Re({ identifier: t, geography: e }).valid;
}
function yn(t) {
  return /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(t);
}
function wn(t) {
  return !!t;
}
function Tn(t) {
  try {
    const e = JSON.stringify(t);
    return e === void 0 ? void 0 : JSON.parse(e);
  } catch {
    return;
  }
}
function bn(t) {
  return Object.keys(t);
}
const Y = "•", H = 4;
function We(t) {
  const e = t.trim();
  if (e.length <= H)
    return Y.repeat(e.length);
  const n = e.slice(-H);
  return `${Y.repeat(
    e.length - H
  )}${n}`;
}
function Dn(t) {
  const e = t.lastIndexOf("@");
  if (e <= 0)
    return We(t);
  const n = t.slice(0, e), r = t.slice(e);
  return `${Y.repeat(n.length)}${r}`;
}
function Sn(t) {
  return t.trim().split(/\s+/).filter(Boolean).map(
    (e) => `${e.slice(0, 1)}${Y.repeat(
      Math.max(e.length - 1, 1)
    )}`
  ).join(" ");
}
const Ye = /^[A-Z0-9]{1,9}$/;
function Nn(t) {
  return Ye.test(t);
}
const Fe = [
  "development",
  "production",
  "staging",
  "demo"
], $e = {
  SE: {
    development: "https://localhost:3000",
    staging: "https://staging.zymego.app",
    production: "https://zymego.app",
    demo: "https://demo.zymego.app"
  },
  UK: {
    development: "https://localhost:3000",
    staging: "https://staging.uk.zymego.app",
    production: "https://uk.zymego.app",
    demo: "https://demo.uk.zymego.app"
  },
  WLS: {
    development: "https://localhost:3000",
    staging: "https://staging.wls.zymego.app",
    production: "https://wls.zymego.app",
    demo: "https://demo.wls.zymego.app"
  }
}, Le = "/n/";
function He(t) {
  const e = t.split("."), n = e.indexOf("zymego");
  return n === -1 || e[n - 1] === "local";
}
function ze(t) {
  return Fe.includes(t);
}
function Mn(t) {
  return He(t) ? "development" : t.split(".").map((e) => e.toLowerCase()).find((e) => ze(e)) ?? "production";
}
function On({
  environment: t,
  geography: e
}) {
  return $e[e][t];
}
function En({
  patientPortalBaseUrl: t,
  shortlinkIdent: e
}) {
  return `${t}${Le}${e}`;
}
const Pn = "23503", Cn = "42703", In = "42P01", vn = "23505";
function xn(t) {
  return t.trim().replaceAll(/\s+/g, "").toUpperCase();
}
function _n(t) {
  if (t.length === 0)
    return;
  const e = Math.floor(Math.random() * t.length);
  return t[e];
}
const An = "+1212555";
function kn(t) {
  return /^\+1...555/.test(t);
}
async function Un({
  isUnique: t
}) {
  for (let n = 0; n < 1e3; n++) {
    const r = Ae();
    if (await t(r))
      return r;
  }
  throw new Error(
    "Failed to generate a unique Swedish personal identity number after 1000 attempts."
  );
}
const Rn = {
  CLINICIAN_ID: "3",
  CLINICIAN_NAME: "Olle Ohlsson",
  COSMIC_PATIENT_IDENTIFIER: "198112189876",
  EDGBASTON_ODS_CODE: "C84143",
  INVALID_SSN: "191212124444",
  MUNTRA_BOOKING_TYPE_EXTERNAL_IDS: ["9", "30"],
  MUNTRA_CAREGIVER_EXTERNAL_IDS: ["15336", "15337"],
  MUNTRA_CLINIC_ID: "7076",
  MUNTRA_PATIENT_EXTERNAL_ID: 1,
  MUNTRA_PATIENT_PHONE_NUMBER: "+46703589806",
  MUNTRA_PATIENT_SSN: "199404205057",
  MUNTRA_START_DATE: "2025-07-12",
  MUNTRA_END_DATE: "2025-07-14",
  OPUS_PATIENT_IDENTIFIER: "198411192399",
  OPUS_START_DATE: "2024-06-05",
  OPUS_END_DATE: "2024-06-05",
  START_DATE: "2024-06-05T00:00:00.000Z",
  END_DATE: "2024-06-05T23:59:00.000Z",
  PATIENT_BOOKING_ID: "28",
  PATIENT_EMAIL: "testers+automation@zymego.com",
  PATIENT_IDENTIFIER: "198411192399",
  PATIENT_PHONE_NUMBER: "+12125551001",
  TIMESLOT_ID: "0",
  TREATMENT_ID: "5",
  TREATMENT_NAME: "New visit"
};
function Wn(t) {
  return Array.isArray(t) ? t : [t];
}
function Yn(t, e) {
  return t.length > e ? e <= 3 ? t.slice(0, e) : `${t.slice(0, e - 3)}...` : t;
}
class Fn extends Map {
  #t = /* @__PURE__ */ new Map();
  #e;
  // eslint-disable-next-line max-params
  constructor(e, n) {
    if (super(e), n) {
      this.#e = n;
      for (const [r] of this) {
        const i = setTimeout(() => {
          this.delete(r);
        }, n);
        this.#t.set(r, i), i.unref();
      }
    }
  }
  clear() {
    for (const e of this.#t.values())
      clearTimeout(e);
    this.#t.clear(), super.clear();
  }
  delete(e) {
    const n = this.#t.get(e);
    return n && (clearTimeout(n), this.#t.delete(e)), super.delete(e);
  }
  // eslint-disable-next-line max-params
  set(e, n, r = this.#e) {
    const i = this.#t.get(e);
    i && clearTimeout(i);
    const o = setTimeout(() => {
      this.delete(e);
    }, r);
    return this.#t.set(e, o), o.unref(), super.set(e, n);
  }
}
function $n(t) {
  return [...new Set(t)];
}
function Ln(t) {
  return t != null && typeof t == "object" && typeof t[Symbol.asyncIterator] == "function";
}
function Hn(t, e) {
  if (t == null)
    throw new Error(`${e} is nullish!`);
  return t;
}
function zn(t) {
  return t.split(/\s+/).map((e) => e.charAt(0).toUpperCase()).join("");
}
function qn(t, e) {
  if (t !== void 0) {
    const n = Number.parseInt(t, 10);
    if (!Number.isNaN(n))
      return n;
  }
  return e?.default;
}
function Bn(t) {
  return `${t.slice(0, 1).toUpperCase()}${t.slice(1)}`;
}
function jn(t, e = 4) {
  if (!t)
    throw new Error("Input must be a non-empty string");
  return `****${t.slice(-e)}`;
}
function Gn(t) {
  return Array.isArray(t) && t.every(
    (e) => e && typeof e.careUnitId == "string" && typeof e.patientType == "string"
  );
}
function Zn(t) {
  const e = String(t);
  if (e.length !== 12)
    throw new Error(
      `Invalid personal number length: expected 12 digits, got ${e.length}`
    );
  const n = e.slice(0, 4), r = e.slice(4, 6), i = e.slice(6, 8);
  return `${n}-${r}-${i}`;
}
function Vn(t) {
  const e = String(t);
  if (e.length !== 12)
    throw new Error("Invalid personal number length");
  return Number(e[8]) % 2 === 0 ? "female" : "male";
}
function qe(t) {
  return t.replaceAll(/[$()*+.?[\\\]^{|}]/g, "\\$&");
}
function Xn({
  input: t,
  keywords: e
}) {
  if (e.length === 0)
    return !1;
  const n = e.map(
    (i) => qe(i.trim())
  );
  return new RegExp(
    `\\b(?<!-)(${n.join("|")})\\b(?!-)`,
    "ui"
  ).test(t);
}
function Qn(t) {
  return t.replaceAll(/([a-z0-9])([A-Z])/g, "$1-$2").replaceAll(/[./\s_]+/g, "-").toLowerCase();
}
const mt = "zymego";
function Be(t) {
  return (t ?? "").toLowerCase().includes(mt);
}
function Jn(t) {
  return !Be(t);
}
function Kn(t) {
  return (t ?? "").toLowerCase() === mt;
}
export {
  Je as CircuitBreaker,
  pt as CircuitBreakerOpenError,
  Y as MASK_CHARACTER,
  Pn as PG_FOREIGN_KEY_VIOLATION,
  Cn as PG_UNDEFINED_COLUMN,
  In as PG_UNDEFINED_TABLE,
  vn as PG_UNIQUE_VIOLATION,
  Rn as TEST_CONSTANTS,
  Fn as TTLMap,
  Hn as assertNotNullish,
  Xe as assertTypeEquals,
  Qe as assertTypeExtends,
  En as buildShortlinkUrl,
  Xn as containsKeyword,
  nr as createCleanupFinalizedAuthRequest,
  rr as createFinalizeAuthRequest,
  sn as deburr,
  Jn as doesNotIncludeZymegoNameLiteral,
  tn as eachUtcDateStringInclusive,
  an as entries,
  cn as findUpsertIndex,
  on as formatDistanceCompact,
  nn as formatHumanDateTime,
  Ue as formatSwedishIdentifier,
  Zn as formatSwedishPersonalNumber,
  ln as generateHsaId,
  Ae as generateSwedishIdentifier,
  Un as generateUniqueSwedishPersonalIdentityNumber,
  un as getBookingTypeDisplayName,
  Mn as getEnvironmentFromHostname,
  Vn as getGenderFromPersonalNumber,
  Ve as getGraphQLErrorCode,
  On as getPatientPortalBaseUrl,
  en as hasPositiveDuration,
  Be as includesZymegoNameLiteral,
  zn as initials,
  Ln as isAsyncIterable,
  Kn as isEqualZymegoNameLiteral,
  yn as isExternalUri,
  gt as isObject,
  Gn as isPatientTypeMap,
  Ie as isPlainDateString,
  kn as isTestPhoneNumber,
  wn as isTruthy,
  fn as isValidHsaId,
  pn as isValidIdentifier,
  dn as isValidNHSNumber,
  Nn as isValidOdsCode,
  hn as isValidSwedishCoordinationNumber,
  gn as isValidSwedishIdentifier,
  mn as isValidSwedishPersonalNumber,
  bn as keys,
  Dn as maskEmail,
  Sn as maskName,
  ir as maskPersonalIdentifiableInformation,
  jn as maskString,
  We as maskValue,
  xn as normalizePostalCode,
  _e as parseHsaId,
  Re as parseIdentifier,
  qn as parseInteger,
  B as parseNHSNumber,
  _ as parseSwedishIdentifier,
  rn as partitionDateRanges,
  Ke as plainDateStringToUtcDate,
  _n as sample,
  or as serializeError,
  sr as serializeResponseBody,
  ar as serializeUrl,
  An as testPhoneNumberPrefix,
  cr as timeoutHook,
  Ze as toApiBaseUrl,
  Wn as toArray,
  Tn as toJsonValue,
  Qn as toKebabCase,
  Yn as truncateWithEllipsis,
  $n as unique,
  Bn as upperFirst
};
//# sourceMappingURL=index.es.js.map
